import { createAction, props } from '@ngrx/store';
import { LookBook } from '@epicuro-next/models/engagement';

import { LookBookEntity } from './model';

export const upsertLookbookEntity = createAction(
  '[Lookbook entities]: upsert one',
  props<{ lookBookEntity: LookBookEntity }>(),
);

export const loadLookbook = createAction(
  '[Lookbook entities]: load one',
  props<{ lookBookId: string }>(),
);

export const loadLookbookSuccess = createAction(
  '[Lookbook entities]: load one success',
  props<{ lookBookId: string; lookBook: LookBook }>(),
);

export const loadLookbookError = createAction(
  '[Lookbook entities]: load one error',
  props<{ lookBookId: string; error: string }>(),
);

export const updateLookBook = createAction(
  '[Lookbook entities]: update look book',
  props<{ lookBookId: string; partialLookBook: Partial<LookBook> }>(),
);
